import React, { useEffect, useState } from 'react';
import { Modal, Form, Tooltip } from 'antd';
import { Button } from '@digital/ui';

import ListMensagem from './ListMensagem';

interface Props {
    mensagens: any[]
}

const ModalComentarios = (props: Props) => {
    const { mensagens } = props
    const [showModal, setShowModal] = useState(false)
    let iconeComentario = ''

    if (mensagens.length > 0) {
        iconeComentario = 'has-comments'
    }

    const handleCancel = () => {
        setShowModal(false)
    }

    return (
        <>
            <Tooltip title="Comentários">
                <Button
                    onClick={() => {
                        setShowModal(true);
                    }}
                    icon="messaging-comments"
                    className={iconeComentario}
                />
            </Tooltip>
            <Modal
                title="Comentário"
                className="chat-modal"
                visible={showModal}
                onCancel={() => {
                    handleCancel();
                }}
                footer={[
                    <Button key="submitCancelar" type="primary" onClick={() => handleCancel()}>
                        Fechar
                    </Button>,
                ]}>
                <ListMensagem mensagens={mensagens} />
            </Modal>
        </>
    );
}

export default ModalComentarios